import React, { useEffect, useState, useRef, memo } from 'react'
import './ImageMarquee.scss'
import cx from 'classnames'

const MarqueeGroupContent = ({ images, ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="marquee__group">
    {images.map((image, index) => {
      const commonProps = {
        key: `partner-${index}`, // Using consistent key prefix
        width: image.width,
        alt: image.name || `Partner ${index + 1}`,
        title: image.name || `Partner ${index + 1}`,
      }
      if (typeof image.src === 'string') {
        return (
          <img
            {...commonProps}
            alt={image.name || `Partner ${index + 1}`}
            className="marquee-item"
            src={image.src}
          />
        )
      } else {
        const ImageComponent = image.src
        // eslint-disable-next-line jsx-a11y/alt-text
        return <ImageComponent {...commonProps} className="marquee-item" />
      }
    })}
  </div>
)

const ImageMarquee = memo(({ images, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false)
  const marqueeRef = useRef(null)

  useEffect(() => {
    const handleMouseEnter = () => {
      setIsHovered(true)
    }

    const handleMouseLeave = () => {
      setIsHovered(false)
    }

    const marqueeElement = marqueeRef.current

    marqueeElement.addEventListener('mouseenter', handleMouseEnter)
    marqueeElement.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      marqueeElement.removeEventListener('mouseenter', handleMouseEnter)
      marqueeElement.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [])

  return (
    <div
      className={cx('wrapper', {
        paused: isHovered,
        mobile: isMobile,
      })}
      ref={marqueeRef}
    >
      <div className="marquee">
        <MarqueeGroupContent images={images} />
        <MarqueeGroupContent images={images} ariaHidden={true} />
      </div>
    </div>
  )
})

export default ImageMarquee
